import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withKeys as _withKeys, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
    class: "sc-file-select"
};
const _hoisted_2 = {
    class: "sc-file-select__side"
};
const _hoisted_3 = {
    class: "sc-file-select__side-add"
};
const _hoisted_4 = {
    class: "sc-file-select__side-search"
};
const _hoisted_5 = {
    class: "sc-file-select__side-menu"
};
const _hoisted_6 = {
    class: "custom-tree-node"
};
const _hoisted_7 = {
    key: 0,
    class: "sc-file-select__side-msg"
};
const _hoisted_8 = {
    class: "sc-file-select__files"
};
const _hoisted_9 = {
    class: "sc-file-select__top"
};
const _hoisted_10 = {
    key: 0,
    class: "upload"
};
const _hoisted_11 = {
    class: "sc-file-select__upload"
};
const _hoisted_12 = {
    class: "tips"
};
const _hoisted_13 = {
    class: "keyword"
};
const _hoisted_14 = {
    class: "sc-file-select__list"
};
const _hoisted_15 = {
    class: "sc-file-select__item__file"
};
const _hoisted_16 = {
    class: "sc-file-select__item__upload"
};
const _hoisted_17 = [
    "onClick"
];
const _hoisted_18 = {
    class: "sc-file-select__item__file"
};
const _hoisted_19 = {
    key: 0,
    class: "sc-file-select__item__checkbox"
};
const _hoisted_20 = {
    key: 1,
    class: "sc-file-select__item__select"
};
const _hoisted_21 = {
    key: 3,
    class: "item-file item-file-doc"
};
const _hoisted_22 = {
    key: 1,
    class: "sc-icon-file-list-fill",
    style: {
        "color": "#999"
    }
};
const _hoisted_23 = [
    "title"
];
const _hoisted_24 = {
    class: "sc-file-select__pagination"
};
const _hoisted_25 = {
    class: "sc-file-select__do"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_button = _resolveComponent("el-button");
    const _component_el_input = _resolveComponent("el-input");
    const _component_el_tree_v2 = _resolveComponent("el-tree-v2");
    const _component_el_upload = _resolveComponent("el-upload");
    const _component_el_icon_warning = _resolveComponent("el-icon-warning");
    const _component_el_icon = _resolveComponent("el-icon");
    const _component_el_empty = _resolveComponent("el-empty");
    const _component_el_progress = _resolveComponent("el-progress");
    const _component_el_image = _resolveComponent("el-image");
    const _component_el_icon_check = _resolveComponent("el-icon-check");
    const _component_el_scrollbar = _resolveComponent("el-scrollbar");
    const _component_el_pagination = _resolveComponent("el-pagination");
    const _component_group_dialog = _resolveComponent("group-dialog");
    const _directive_loading = _resolveDirective("loading");
    return _openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "el-icon-plus",
                        onClick: $options.addGroup
                    }, {
                        default: _withCtx(()=>[
                                ..._cache[5] || (_cache[5] = [
                                    _createTextVNode("新增分类", -1)
                                ])
                            ]),
                        _: 1
                    }, 8, [
                        "onClick"
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_input, {
                        modelValue: $data.query,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.query = $event),
                        placeholder: "请输入分类名称",
                        clearable: "",
                        onInput: $options.onQueryChanged
                    }, null, 8, [
                        "modelValue",
                        "onInput"
                    ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_el_tree_v2, {
                        ref: "group",
                        class: "menu",
                        data: $data.menu,
                        "node-key": $data.treeProps.key,
                        props: $data.treeProps,
                        "current-node-key": $data.menuId,
                        onNodeClick: $options.groupClick,
                        "item-size": 36,
                        height: 427,
                        "expand-on-click-node": false,
                        "filter-method": $options.filterMethod
                    }, {
                        default: _withCtx(({ node })=>[
                                _createElementVNode("span", _hoisted_6, [
                                    _createElementVNode("span", {
                                        class: _normalizeClass([
                                            "el-tree-node__label",
                                            {
                                                'el-tree-node__label_active': $data.menuId === node.key
                                            }
                                        ])
                                    }, _toDisplayString(node.label), 3),
                                    node.key !== 1 ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "btnGroup",
                                        onClick: _cache[1] || (_cache[1] = _withModifiers(()=>{}, [
                                            "stop"
                                        ]))
                                    }, [
                                        _createVNode(_component_el_button, {
                                            size: "small",
                                            icon: "el-icon-edit",
                                            circle: "",
                                            onClick: _withModifiers(($event)=>$options.editGroup(node.data), [
                                                "stop"
                                            ])
                                        }, null, 8, [
                                            "onClick"
                                        ]),
                                        _createVNode(_component_el_button, {
                                            size: "small",
                                            type: "danger",
                                            icon: "el-icon-delete",
                                            circle: "",
                                            onClick: _withModifiers(($event)=>$options.delGroup(node.data), [
                                                "stop"
                                            ])
                                        }, null, 8, [
                                            "onClick"
                                        ])
                                    ])) : _createCommentVNode("", true)
                                ])
                            ]),
                        _: 1
                    }, 8, [
                        "data",
                        "node-key",
                        "props",
                        "current-node-key",
                        "onNodeClick",
                        "filter-method"
                    ])
                ]),
                $props.multiple ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _cache[6] || (_cache[6] = _createTextVNode(" 已选择 ", -1)),
                    _createElementVNode("b", null, _toDisplayString($data.value.length), 1),
                    _cache[7] || (_cache[7] = _createTextVNode(" / ", -1)),
                    _createElementVNode("b", null, _toDisplayString($props.max), 1),
                    _cache[8] || (_cache[8] = _createTextVNode(" 项 ", -1))
                ])) : _createCommentVNode("", true)
            ])), [
                [
                    _directive_loading,
                    $data.menuLoading
                ]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                    !$props.hideUpload ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_el_upload, {
                            class: "sc-file-select__upload",
                            action: "",
                            multiple: "",
                            "show-file-list": false,
                            accept: $data.accept,
                            "on-change": $options.uploadChange,
                            "before-upload": $options.uploadBefore,
                            "on-progress": $options.uploadProcess,
                            "on-success": $options.uploadSuccess,
                            "on-error": $options.uploadError,
                            "http-request": $options.uploadRequest
                        }, {
                            default: _withCtx(()=>[
                                    _createVNode(_component_el_button, {
                                        type: "primary",
                                        icon: "el-icon-upload"
                                    }, {
                                        default: _withCtx(()=>[
                                                ..._cache[9] || (_cache[9] = [
                                                    _createTextVNode("本地上传", -1)
                                                ])
                                            ]),
                                        _: 1
                                    })
                                ]),
                            _: 1
                        }, 8, [
                            "accept",
                            "on-change",
                            "before-upload",
                            "on-progress",
                            "on-success",
                            "on-error",
                            "http-request"
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_el_button, {
                                type: "danger",
                                icon: "el-icon-delete",
                                disabled: $data.value.length <= 0,
                                onClick: $options.deleteFile
                            }, {
                                default: _withCtx(()=>[
                                        ..._cache[10] || (_cache[10] = [
                                            _createTextVNode("删除图片", -1)
                                        ])
                                    ]),
                                _: 1
                            }, 8, [
                                "disabled",
                                "onClick"
                            ])
                        ]),
                        _createElementVNode("span", _hoisted_12, [
                            _createVNode(_component_el_icon, null, {
                                default: _withCtx(()=>[
                                        _createVNode(_component_el_icon_warning)
                                    ]),
                                _: 1
                            }),
                            _createTextVNode("大小不超过" + _toDisplayString($props.maxSize) + "MB", 1)
                        ])
                    ])) : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_el_input, {
                            modelValue: $data.fileName,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.fileName = $event),
                            "prefix-icon": "el-icon-search",
                            placeholder: "请输入名称",
                            clearable: "",
                            onKeyup: _withKeys($options.search, [
                                "enter"
                            ]),
                            onClear: $options.search
                        }, null, 8, [
                            "modelValue",
                            "onKeyup",
                            "onClear"
                        ]),
                        _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: $options.search
                        }, {
                            default: _withCtx(()=>[
                                    ..._cache[11] || (_cache[11] = [
                                        _createTextVNode("查询", -1)
                                    ])
                                ]),
                            _: 1
                        }, 8, [
                            "onClick"
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_el_scrollbar, {
                        ref: "scrollbar"
                    }, {
                        default: _withCtx(()=>[
                                $data.fileList.length == 0 && $data.data.length == 0 ? (_openBlock(), _createBlock(_component_el_empty, {
                                    key: 0,
                                    description: "无数据",
                                    "image-size": 80
                                })) : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fileList, (file, index)=>{
                                    return _openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: "sc-file-select__item"
                                    }, [
                                        _createElementVNode("div", _hoisted_15, [
                                            _createElementVNode("div", _hoisted_16, [
                                                _createVNode(_component_el_progress, {
                                                    type: "circle",
                                                    percentage: file.progress,
                                                    width: 70
                                                }, null, 8, [
                                                    "percentage"
                                                ])
                                            ]),
                                            _createVNode(_component_el_image, {
                                                src: file.tempImg,
                                                fit: "cover",
                                                loading: "lazy"
                                            }, null, 8, [
                                                "src"
                                            ])
                                        ])
                                    ]);
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.data, (item)=>{
                                    return _openBlock(), _createElementBlock("div", {
                                        key: item[$data.fileProps.key],
                                        class: _normalizeClass([
                                            "sc-file-select__item",
                                            {
                                                active: $data.value.includes(item[$data.fileProps.url])
                                            }
                                        ]),
                                        onClick: ($event)=>$options.select(item)
                                    }, [
                                        _createElementVNode("div", _hoisted_18, [
                                            $props.multiple ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                _createVNode(_component_el_icon, null, {
                                                    default: _withCtx(()=>[
                                                            _createVNode(_component_el_icon_check)
                                                        ]),
                                                    _: 1
                                                })
                                            ])) : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                _createVNode(_component_el_icon, null, {
                                                    default: _withCtx(()=>[
                                                            _createVNode(_component_el_icon_check)
                                                        ]),
                                                    _: 1
                                                })
                                            ])),
                                            _cache[12] || (_cache[12] = _createElementVNode("div", {
                                                class: "sc-file-select__item__box"
                                            }, null, -1)),
                                            $options._isImg(item[$data.fileProps.url]) ? (_openBlock(), _createBlock(_component_el_image, {
                                                key: 2,
                                                src: item[$data.fileProps.url],
                                                fit: "cover",
                                                loading: "lazy"
                                            }, null, 8, [
                                                "src"
                                            ])) : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                $data.files[$options._getExt(item[$data.fileProps.url])] ? (_openBlock(), _createElementBlock("i", {
                                                    key: 0,
                                                    class: _normalizeClass($data.files[$options._getExt(item[$data.fileProps.url])].icon),
                                                    style: _normalizeStyle({
                                                        color: $data.files[$options._getExt(item[$data.fileProps.url])].color
                                                    })
                                                }, null, 6)) : (_openBlock(), _createElementBlock("i", _hoisted_22))
                                            ]))
                                        ]),
                                        _createElementVNode("p", {
                                            title: item[$data.fileProps.fileName] || '-'
                                        }, _toDisplayString(item[$data.fileProps.fileName] || '-'), 9, _hoisted_23)
                                    ], 10, _hoisted_17);
                                }), 128))
                            ]),
                        _: 1
                    }, 512)
                ]),
                _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_el_pagination, {
                        size: "small",
                        background: "",
                        layout: "prev, pager, next",
                        total: $data.total,
                        "page-size": $data.pageSize,
                        currentPage: $data.currentPage,
                        "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event)=>$data.currentPage = $event),
                        onCurrentChange: $options.reload
                    }, null, 8, [
                        "total",
                        "page-size",
                        "currentPage",
                        "onCurrentChange"
                    ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                    _renderSlot(_ctx.$slots, "do", {}, undefined, true),
                    _createVNode(_component_el_button, {
                        type: "primary",
                        disabled: $data.value.length <= 0,
                        onClick: $options.submit
                    }, {
                        default: _withCtx(()=>[
                                ..._cache[13] || (_cache[13] = [
                                    _createTextVNode("确 定", -1)
                                ])
                            ]),
                        _: 1
                    }, 8, [
                        "disabled",
                        "onClick"
                    ])
                ])
            ])), [
                [
                    _directive_loading,
                    $data.listLoading
                ]
            ])
        ]),
        $data.dialog.save ? (_openBlock(), _createBlock(_component_group_dialog, {
            key: 0,
            ref: "groupDialog",
            onSuccess: $options.handleSuccess,
            onClosed: _cache[4] || (_cache[4] = ($event)=>$data.dialog.save = false)
        }, null, 8, [
            "onSuccess"
        ])) : _createCommentVNode("", true)
    ], 64);
}
